import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../../actions';

const ValidateOtp = () => {
    const location = useLocation(); // Get state from the route
    const dispatch = useDispatch();
    const branding = useSelector((state) => state.organization?.branding);
    const bgStyle = branding?.cmsLoginBgUrl
        ? { backgroundImage: `url(${branding.cmsLoginBgUrl})` }
        : undefined;

    const [otp, setOtp] = useState('');
    const [submitted, setSubmitted] = useState(false);

    // Extract username from location state
    const username = location.state?.username;

    const handleChange = (e) => {
        setOtp(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);

        if (username && otp) {
            dispatch(userActions.validateopt(username, otp));
        }
    };

    return (
        <React.Fragment>
            <div className='login-bgimage' style={bgStyle}>
                <div className="col-sm-8 col-sm-offset-2">
                    <div className='row' style={{ marginTop: '120px' }}>
                        <div className="col-md-6" />
                        <div className="col-md-6 card bg-white">
                            <h3 style={{ textAlign: 'center' }}>Validate Security Code</h3>
                            <form name="form" onSubmit={handleSubmit}>
                                <div className={'form-group' + (submitted && !otp ? ' has-error' : '')}>
                                    <label htmlFor="otp">Security Code</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="otp"
                                        value={otp}
                                        onChange={handleChange}
                                    />
                                    {submitted && !otp &&
                                        <div className="help-block">Security Code is required</div>
                                    }
                                </div>
                                <div className="form-group">
                                    <button className="btn btn-primary">Validate</button>
                                    <Link to='/login' className='pull-right mt-10 mr-10'>Back to Login</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ValidateOtp;